import { IconButton } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

import useStyles from './styles'

interface IProps {
  handleOpen: () => void
}

export const MoreButton = ({ handleOpen }: IProps) => {
  const classes = useStyles({})

  return (
    <IconButton className={classes.moreIconWrapper} onClick={handleOpen}>
      <MoreHorizIcon className={classes.moreIcon} />
    </IconButton>
  )
}
